import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { COMPLIANCE, REVIEW } from "const"
import {
    projectsRoute,
    projectCcComplianceRoute,
    projectCcReviewRoute,
    projectCcRequirementsReviewRoute,
} from "client/parts/routes"
import { useInput } from "client/utils"
import { StoreType, addModal } from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    FormGroup,
    Label,
    Input,
    Feedback,
    Button,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import ComplianceAnswer from "./complianceAnswer"
import ReviewComplianceAnswer from "./reviewComplianceAnswer"
import ReviewReviewAnswer from "./reviewReviewAnswer"
import RequirementAnswer from "./requirementReviewAnswer"

const CcFixComplianceAnswer = () => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [url, setUrl] = useInput("")
    const [validation, setValidation] = useState<string>(null)

    const onLoad = () => {
        setValidation(null)
        const paramArray: number[] = []

        const urlArray = url.split("/")
        urlArray.forEach((row) => {
            const parsed = parseInt(row, 10)
            if (parsed > 0) paramArray.push(parsed)
        })

        if (
            url.indexOf(projectsRoute) >= 0
            && url.indexOf(projectCcComplianceRoute) > 0
            && paramArray.length === 4
        ) {
            dispatch(addModal({
                key: "complianceAnswer",
                content: <ComplianceAnswer
                    projectId={paramArray[0]}
                    setId={paramArray[1]}
                    revisionId={paramArray[2]}
                    itemId={paramArray[3]}
                />,
            }))
        } else if (
            url.indexOf(projectsRoute) >= 0
            && url.indexOf(`${projectCcReviewRoute}/${COMPLIANCE}`) > 0
            && paramArray.length === 6
        ) {
            dispatch(addModal({
                key: "reviewComplianceAnswer",
                content: <ReviewComplianceAnswer
                    projectId={paramArray[0]}
                    setId={paramArray[3]}
                    revisionId={paramArray[4]}
                    complianceItemId={paramArray[5]}
                />,
            }))
        } else if (
            url.indexOf(projectsRoute) >= 0
            && url.indexOf(`${projectCcReviewRoute}/${REVIEW}`) > 0
            && paramArray.length === 5
        ) {
            dispatch(addModal({
                key: "reviewReviewAnswer",
                content: <ReviewReviewAnswer
                    projectId={paramArray[0]}
                    fileId={paramArray[1]}
                    reviewItemId={paramArray[3]} // versionId is not used here
                    revisionId={paramArray[4]}
                />,
            }))
        } else if (
            url.indexOf(projectsRoute) >= 0
            && url.indexOf(projectCcRequirementsReviewRoute) > 0
            && paramArray.length === 3
        ) {
            dispatch(addModal({
                key: "requirementAnswer",
                content: <RequirementAnswer
                    projectId={paramArray[0]}
                    requirementId={paramArray[1]}
                    revisionId={paramArray[2]}
                />,
            }))
        } else {
            setValidation(lang.validationWrongUrl)
        }
    }

    const viewAccess = userData.accountId === 1

    if (!viewAccess) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.ccFixComplianceAnswer}</PageTitle>
            </PageHeader>
            <PageContent>
                <PageForm>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.enterComplianceAnswerUrl}</Label>
                                <Input type="text" value={url} onChange={setUrl} />
                                <Feedback>{validation && validation}</Feedback>
                            </FormGroup>
                        </Col>
                        <Col xs={12}>
                            <Button variant="success" onClick={onLoad}>
                                {lang.load}
                            </Button>
                        </Col>
                    </Row>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default CcFixComplianceAnswer
